import axios from 'axios';

const checkSyntax = params => {
  return axios.post('templates/is-valid', params);
};

export { checkSyntax };
